exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-insert-shape-background-3haq2{background:#fff}.index-insert-shape-toolbar-Woihs{overflow-y:auto;overflow-x:hidden;padding:8px 0;border:1px solid rgba(0,0,0,.12);border-radius:4px;position:absolute}.index-insert-shape-menu-2meRu,.index-insert-shape-toolbar-Woihs{-webkit-transform:scaleX(1) translate(0);transform:scaleX(1) translate(0);-webkit-user-select:none;-ms-user-select:none;user-select:none;z-index:5}.index-insert-shape-menu-2meRu{height:auto;overflow:hidden;position:relative;top:0;left:0}", ""]);

// Exports
exports.locals = {
	"insert-shape-background": "index-insert-shape-background-3haq2",
	"insert-shape-toolbar": "index-insert-shape-toolbar-Woihs",
	"insert-shape-menu": "index-insert-shape-menu-2meRu"
};